import { IS_DEV } from 'config';

export const GA_ID = 'UA-132891725-1';
export const GA_TEST_MODE = IS_DEV;
